$(".prod-list li").hover(function(){
    $(this).parent().find('.sub-nav').css("display", "none");
    $(this).find('.sub-nav').css("display", "block");
}, function(){
   // $(this).find('.sub-nav').css("display", "none");
});

$("#productsDropdown").click(function(){

    $('.prod-list').css("width", "100%");
    $('.prod-list').attr("minWidth", "100");
    $('.prod-sub-menu li').css("display", "none");
});


$(".mn-0.has-children").hover(function(){
    $('.prod-sub-menu li').css("display", "none").css("opacity", "0");
    openSubMenu('.mmn-0');

    $('.prod-list').css("width", "70%").attr("minWidth", "70");
});
$(".mn-1.has-children").hover(function(){
    $('.prod-sub-menu li').css("display", "none").css("opacity", "0");
    openSubMenu('.mmn-1');
    $('.prod-list').css("width", "70%").attr("minWidth", "70");
});
$(".mn-2.has-children").hover(function(){
    $('.prod-sub-menu li').css("display", "none").css("opacity", "0");
    openSubMenu('.mmn-2');
    $('.prod-list').css("width", "70%").attr("minWidth", "70");
});
$(".mn-3.has-children").hover(function(){
    $('.prod-sub-menu li').css("display", "none").css("opacity", "0");
    openSubMenu('.mmn-3');
    $('.prod-list').css("width", "70%").attr("minWidth", "70");
});
$(".mn-4.has-children").hover(function(){
    $('.prod-sub-menu li').css("display", "none").css("opacity", "0");
    openSubMenu('.mmn-4');
    $('.prod-list').css("width", "70%").attr("minWidth", "70");
});
$(".mn-5.has-children").hover(function(){
    $('.prod-sub-menu li').css("display", "none").css("opacity", "0");
    openSubMenu('.mmn-5');
    $('.prod-list').css("width", "70%").attr("minWidth", "70");
});
$(".mn-6.has-children").hover(function(){
    $('.prod-sub-menu li').css("display", "none").css("opacity", "0");
    openSubMenu('.mmn-6');
    $('.prod-list').css("width", "70%").attr("minWidth", "70");
});
$(".mn-7.has-children").hover(function(){
    $('.prod-sub-menu li').css("display", "none").css("opacity", "0");
    openSubMenu('.mmn-7');
    $('.prod-list').css("width", "70%").attr("minWidth", "70");
});
$(".mn-8.has-children").hover(function(){
    $('.prod-sub-menu li').css("display", "none").css("opacity", "0");
    openSubMenu('.mmn-8');
    $('.prod-list').css("width", "70%").attr("minWidth", "70");
});
$(".mn-9.has-children").hover(function(){
    $('.prod-sub-menu li').css("display", "none").css("opacity", "0");
    openSubMenu('.mmn-9');
    $('.prod-list').css("width", "70%").attr("minWidth", "70");
});
$(".no-children").hover(function(){
    $('.prod-sub-menu li').css("display", "none").css("opacity", "0");
    $('.prod-list').css("width", "100%").attr("minWidth", "100");
});

function openSubMenu(menu) {
    if ($('.prod-list').attr('minWidth') == '70' ) {
        $(menu).css("display", "block").css("opacity", "1");
        console.log('pa vonese');
    }
    else {
        setTimeout(
            function()
            {
                $(menu).css("display", "block").css("opacity", "1");
            }, 0);
        console.log('me vonese');
    }
}

$(".show-all-products").click(function(){
    $(".show-all-more").show();
    $(".show-all-products").hide();
});

$('.mobile-dropdown').parent().on('shown.bs.dropdown', function () {
    $('.dark-back').show();
    $('.dark-back').css('height', '100%');
});
$('.desktop-dropdown').parent().on('shown.bs.dropdown', function () {
    $('.dark-back').show();

    if($(window).width() >= 991){
        var offset = $(this).find('.dropdown-menu').offset();
        var marginTop = $(this).find('.dropdown-menu').css('margin-top');
        var newPosition = offset.top - parseInt(marginTop);
        $('.dark-back').css('height', 'calc(100% - ' + newPosition + 'px)');
    }else{
        $('.dark-back').css('height', '100%');
    }
    // $('body').css('overflow', 'hidden');
});
$('.desktop-dropdown').parent().on('hidden.bs.dropdown', function () {
    $('.dark-back').hide();
    // $('body').css('overflow-y', 'auto');
});

$('.desktop-dropdown-top').parent().on('shown.bs.dropdown', function () {
    $('.dark-back-top').show();

    if($(window).width() >= 991){
        var offset = $(this).find('.dropdown-menu').offset();
        var marginTop = $(this).find('.dropdown-menu').css('margin-top');
        var newPosition = offset.top - parseInt(marginTop);
        $('.dark-back-top').css('height', 'calc(100% - ' + newPosition + 'px)');
    }else{
        $('.dark-back-top').css('height', '100%');
    }
    // $('body').css('overflow', 'hidden');
});
$('.desktop-dropdown-top').parent().on('hidden.bs.dropdown', function () {
    $('.dark-back-top').hide();
    $('#change-country').hide();
    $('#choose-language').show();
    $('#langugage-mob-ddl-panel').show();

    // $('body').css('overflow-y', 'auto');
});

$('.mobile-dropdown').parent().on('hidden.bs.dropdown', function () {
    $('.dark-back').hide();
})
$(document).on('click', '.dropdown-menu', function (e) {
    e.stopPropagation();
});
$('.close-dropdown').on('click', function () {
    $('.dark-back').hide();
    $('.dark-back-top').hide();
    $('#change-country').hide();
    $('#choose-language').show();
    $('#langugage-mob-ddl-panel').show();
});
// $('.arrow-link').each(function(){
//     $(this).append(' <img src="{{root}}http://www.anestiwatadev.com/wp-content/themes/anestiwata/images/icons/Arrow.svg">');
// });
/*
$(window).on("load resize", function(){
    var divHeight = $('.m01').find('.container').outerHeight() + 110;
    $('.m01').find('.background-shape').css('height', divHeight+'px');
    var containerWidth = $('#container-width').width();
    if($(window).width() >= 991){
        $('.c-2-w').css('width', containerWidth * 0.1666667);
        $('.o-1-c').css('margin-left', containerWidth * 0.0833333);
    }else{
        $('.c-2-w').css('width', '100%');
        $('.o-1-c').css('margin-left', '0');
    }
});
*/
$(window).on("load resize", function(){
    var divHeight = $('.m30').find('.container').outerHeight() + 110;
    $('.m30').find('.background-shape').css('height', divHeight+'px');
});
$(document).ready(function() {
    $(window).resize(function(){
        if ($(window).width() >= 980){

            $(".navbar .dropdown-toggle").hover(function () {
                $(this).parent().toggleClass("show");
                $(this).parent().find(".dropdown-menu").toggleClass("show");
            });
            // $( ".navbar .dropdown-menu" ).mouseleave(function() {
            //     $(this).removeClass("show");
            // });
        }
    });
});
var x, i, j, selElmnt, a, b, c;
/*look for any elements with the class "default-select":*/
x = document.getElementsByClassName("default-select-country");
for (i = 0; i < x.length; i++) {
    selElmnt = x[i].getElementsByTagName("select")[0];
    /*for each element, create a new DIV that will act as the selected item:*/
    a = document.createElement("DIV");
    a.setAttribute("class", "select-selected");

    a.innerHTML = selElmnt.options[selElmnt.selectedIndex].innerHTML;

    x[i].appendChild(a);
    /*for each element, create a new DIV that will contain the option list:*/
    b = document.createElement("DIV");
    b.setAttribute("class", "select-items select-hide");

    for (j = 1; j < selElmnt.length; j++) {
        /*for each option in the original select element,
        create a new DIV that will act as an option item:*/
        c = document.createElement("DIV");
        c.innerHTML = selElmnt.options[j].innerHTML;

        c.addEventListener("click", function(e) {
            /*when an item is clicked, update the original select box,
            and the selected item:*/
            var y, i, k, s, h;
            s = this.parentNode.parentNode.getElementsByTagName("select")[0];
            h = this.parentNode.previousSibling;
            for (i = 0; i < s.length; i++) {
                if (s.options[i].innerHTML == this.innerHTML) {
                    jQuery('#btn-change-location').attr("data-redirect-url", s.options[i].value);
                    jQuery('#change-country').show();
                    jQuery('#choose-language').hide();
                    jQuery('#langugage-mob-ddl-panel').hide();

                    s.selectedIndex = i;
                    h.innerHTML = this.innerHTML;
                    y = this.parentNode.getElementsByClassName("same-as-selected");
                    for (k = 0; k < y.length; k++) {
                        y[k].removeAttribute("class");
                    }
                    this.setAttribute("class", "same-as-selected");
                    break;
                }
            }
            h.click();
        });
        b.appendChild(c);
    }
    x[i].appendChild(b);
    a.addEventListener("click", function(e) {
        /*when the select box is clicked, close any other select boxes,
        and open/close the current select box:*/
        e.stopPropagation();
        closeAllSelect(this);
        this.nextSibling.classList.toggle("select-hide");
        this.classList.toggle("select-arrow-active");

    });
}


x = document.getElementsByClassName("default-select-language");
for (i = 0; i < x.length; i++) {
    selElmnt = x[i].getElementsByTagName("select")[0];
    /*for each element, create a new DIV that will act as the selected item:*/
    a = document.createElement("DIV");
    a.setAttribute("class", "select-selected");

   // a.innerHTML = selElmnt.options[selElmnt.selectedIndex].innerHTML;

    x[i].appendChild(a);
    /*for each element, create a new DIV that will contain the option list:*/
    b = document.createElement("DIV");
    b.setAttribute("class", "select-items select-hide");

    for (j = 1; j < selElmnt.length; j++) {
        /*for each option in the original select element,
        create a new DIV that will act as an option item:*/
        c = document.createElement("DIV");
        c.innerHTML = selElmnt.options[j].innerHTML;

        c.addEventListener("click", function(e) {
            /*when an item is clicked, update the original select box,
            and the selected item:*/
            var y, i, k, s, h;
            s = this.parentNode.parentNode.getElementsByTagName("select")[0];
            h = this.parentNode.previousSibling;
            for (i = 0; i < s.length; i++) {
                if (s.options[i].innerHTML == this.innerHTML) {
                    window.location.href = s.options[i].value;


                    s.selectedIndex = i;
                    h.innerHTML = this.innerHTML;
                    y = this.parentNode.getElementsByClassName("same-as-selected");
                    for (k = 0; k < y.length; k++) {
                        y[k].removeAttribute("class");
                    }
                    this.setAttribute("class", "same-as-selected");
                    break;
                }
            }
            h.click();
        });
        b.appendChild(c);
    }
    x[i].appendChild(b);
    a.addEventListener("click", function(e) {
        /*when the select box is clicked, close any other select boxes,
        and open/close the current select box:*/
        e.stopPropagation();
        closeAllSelect(this);
        this.nextSibling.classList.toggle("select-hide");
        this.classList.toggle("select-arrow-active");

    });
}



function closeAllSelect(elmnt) {
    /*a function that will close all select boxes in the document,
    except the current select box:*/
    var x, y, i, arrNo = [];
    x = document.getElementsByClassName("select-items");
    y = document.getElementsByClassName("select-selected");
    for (i = 0; i < y.length; i++) {
        if (elmnt == y[i]) {
            arrNo.push(i)
        } else {
            y[i].classList.remove("select-arrow-active");
        }
    }
    for (i = 0; i < x.length; i++) {
        if (arrNo.indexOf(i)) {
            x[i].classList.add("select-hide");
        }
    }
}

/*if the user clicks anywhere outside the select box,
then close all select boxes:*/
document.addEventListener("click", closeAllSelect);

var x, i, j, selElmnt, a, b, c;
/*look for any elements with the class "formfield-select":*/
x = document.getElementsByClassName("formfield-select");
for (i = 0; i < x.length; i++) {
    selElmnt = x[i].getElementsByTagName("select")[0];
    /*for each element, create a new DIV that will act as the selected item:*/
    a = document.createElement("DIV");
    a.setAttribute("class", "select-selected");
    a.innerHTML = selElmnt.options[selElmnt.selectedIndex].innerHTML;
    x[i].appendChild(a);
    /*for each element, create a new DIV that will contain the option list:*/
    b = document.createElement("DIV");
    b.setAttribute("class", "select-items select-hide");
    for (j = 1; j < selElmnt.length; j++) {
        /*for each option in the original select element,
        create a new DIV that will act as an option item:*/
        c = document.createElement("DIV");
        c.innerHTML = selElmnt.options[j].innerHTML;
        c.addEventListener("click", function(e) {
            /*when an item is clicked, update the original select box,
            and the selected item:*/
            var y, i, k, s, h;
            s = this.parentNode.parentNode.getElementsByTagName("select")[0];
            h = this.parentNode.previousSibling;
            for (i = 0; i < s.length; i++) {
                if (s.options[i].innerHTML == this.innerHTML) {
                    s.selectedIndex = i;
                    h.innerHTML = this.innerHTML;
                    y = this.parentNode.getElementsByClassName("same-as-selected");
                    for (k = 0; k < y.length; k++) {
                        y[k].removeAttribute("class");
                    }
                    this.setAttribute("class", "same-as-selected");
                    break;
                }
            }
            h.click();
        });
        b.appendChild(c);
    }
    x[i].appendChild(b);
    a.addEventListener("click", function(e) {
        /*when the select box is clicked, close any other select boxes,
        and open/close the current select box:*/
        e.stopPropagation();
        closeAllSelect(this);
        this.nextSibling.classList.toggle("select-hide");
        this.classList.toggle("select-arrow-active");
    });
}
function closeAllSelect(elmnt) {
    /*a function that will close all select boxes in the document,
    except the current select box:*/
    var x, y, i, arrNo = [];
    x = document.getElementsByClassName("select-items");
    y = document.getElementsByClassName("select-selected");
    for (i = 0; i < y.length; i++) {
        if (elmnt == y[i]) {
            arrNo.push(i)
        } else {
            y[i].classList.remove("select-arrow-active");
        }
    }
    for (i = 0; i < x.length; i++) {
        if (arrNo.indexOf(i)) {
            x[i].classList.add("select-hide");
        }
    }
}
/*if the user clicks anywhere outside the select box,
then close all select boxes:*/
document.addEventListener("click", closeAllSelect);$(window).on("load resize", function(){
    var divHeight = $('.m02').find('.container').outerHeight() + 180;
    $('.m02').find('.background-shape').css('height', divHeight+'px');
    var containerWidth = $('#container-width').width();
    if($(window).width() >= 991){
        $('.c-2-w').css('width', containerWidth * 0.1666667);
        $('.o-1-c').css('margin-left', containerWidth * 0.0833333);
    }else{
        $('.c-2-w').css('width', '100%');
        $('.o-1-c').css('margin-left', '0');
    }
});



$( "#language-mob" ).click(function() {
    $('#languageDropdown').trigger("click");
});

$( "#btn-change-location" ).click(function() {
    window.location.href = location.protocol + "//" + location.host + '?c='+ $(this).attr("data-redirect-url");
});
/*
$('.pager').click(() => {
    $('html, body').animate({
        scrollTop: $('.m37.in-content-38').offset().top + (-50)
    }, 600);
});
*/